import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { PreferenceInputMode } from '@/pages/settings/ShiftPatternsSettingsPage';

/**
 * v0.4 追加7要件⑤ (D-235): shift_preference_input_mode の実効値を解決する。
 * 未設定 (value=null) はテナント既定の 'both' として扱う (§6-0 原則3、設定していないテナントは
 * 従来どおりパターン選択・時刻入力の両方を使える)。
 * 設計: docs/design/v04-shift-additional-requirements.md §2-2(c) / §10 D-235
 */
type ResolveResponse = { value: PreferenceInputMode | null };

export const usePreferenceInputMode = (nodeId: string | null | undefined): PreferenceInputMode => {
  const { data } = useQuery<ResolveResponse>({
    queryKey: ['shift-preference-input-mode', nodeId],
    queryFn: () => apiFetch(`/inheritable-settings/shift_preference_input_mode/resolve?node_id=${encodeURIComponent(nodeId!)}`),
    enabled: !!nodeId,
  });
  return data?.value ?? 'both';
};
